/* eslint-disable max-len */
import React from 'react';

const Unblock: React.FC<object> = () => {

    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.07143 5.25V3.75C2.07143 2.75544 2.48533 1.80161 3.22208 1.09835C3.95883 0.395088 4.95808 0 6 0C7.04192 0 8.04117 0.395088 8.77792 1.09835C9.51467 1.80161 9.92857 2.75544 9.92857 3.75V5.25C10.3453 5.25 10.745 5.40804 11.0397 5.68934C11.3344 5.97064 11.5 6.35218 11.5 6.75V10.5C11.5 10.8978 11.3344 11.2794 11.0397 11.5607C10.745 11.842 10.3453 12 9.92857 12H2.07143C1.65466 12 1.25496 11.842 0.960261 11.5607C0.665561 11.2794 0.5 10.8978 0.5 10.5V6.75C0.5 6.35218 0.665561 5.97064 0.960261 5.68934C1.25496 5.40804 1.65466 5.25 2.07143 5.25ZM8.35714 3.75V5.25H3.64286V3.75C3.64286 3.15326 3.8912 2.58097 4.33325 2.15901C4.7753 1.73705 5.37485 1.5 6 1.5C6.62515 1.5 7.2247 1.73705 7.66675 2.15901C8.1088 2.58097 8.35714 3.15326 8.35714 3.75Z"
                fill="#899696"
            />
        </svg>
    );
};

export default Unblock;